import { z } from 'zod';
import { JsonValueZod } from './json.value.zod';
import { ValidationAttachTargetZod } from './validation.attach.target.zod';

// One named validation declaration. May span multiple binds (`binds`),
// resolves through a registered ValidatorCapability (`type`), and renders
// its error on `attachTo` — a typed target so the same validator can
// surface on a field, section header, tab indicator, or form-level panel.
//
// Field-level validators (single-bind) live on FieldSchema.validators
// instead. This schema is for cross-cutting validations that span more
// than one bind or whose error displays at a higher level than the field.
export const ValidationSchemaZod = z.object({
  id: z.string().min(1),
  type: z.string().min(1),
  binds: z.array(z.string().min(1)).optional(),
  attachTo: ValidationAttachTargetZod,
  config: z.record(z.string(), JsonValueZod).optional(),
  message: z.string().optional(),
}).strict();

export type ValidationSchema = z.infer<typeof ValidationSchemaZod>;
